module.exports = __webpack_public_path__ + "static/img/BUBLY_SMILE-BLUE-POM.3129b33.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/BUBLY_SMILE-BLUE-POM.gif
// module id = fhzn
// module chunks = 0